import { AnswerStats } from "@/models/answerStats";

export class StatsDto {
  businessPartnerAnswerStats: AnswerStats = new AnswerStats();
  tier1AnswerStats: AnswerStats = new AnswerStats();
  supplyChainAnswerStats: AnswerStats = new AnswerStats();
  countries: string[] = [];
}

